import { render, staticRenderFns } from "./menu-manage-modal.vue?vue&type=template&id=774f8f90&"
import script from "./menu-manage-modal.vue?vue&type=script&lang=js&"
export * from "./menu-manage-modal.vue?vue&type=script&lang=js&"
import style0 from "./menu-manage-modal.vue?vue&type=style&index=0&id=774f8f90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports